import BaseController from "niteroi/packages/system/controllers/Base.controller";

export default class Projects extends BaseController {
    public onInit(): void {
        super.onInit();
    }
}
